/**
 * i18n (Internationalization) configuration
 * Vue I18n v9 для Vue 3
 */

import { createI18n } from 'vue-i18n'
import en from './locales/en'
import ru from './locales/ru'

/**
 * Типизация для переводов
 * Это даст автокомплит в $t('...')
 */
export type MessageSchema = typeof en

/**
 * Доступные языки
 */
export type Locale = 'en' | 'ru'

/**
 * Получить сохраненный язык из localStorage
 */
function getSavedLocale(): Locale {
  const saved = localStorage.getItem('locale')
  if (saved === 'en' || saved === 'ru') {
    return saved
  }
  return 'en' // По умолчанию английский
}

/**
 * Создание i18n instance
 */
export const i18n = createI18n<[MessageSchema], Locale, false>({
  legacy: false, // Composition API mode (не legacy mode)
  locale: getSavedLocale(), // Загружаем из localStorage
  fallbackLocale: 'en', // Fallback если перевод не найден
  messages: {
    en,
    ru,
  },
  // Дополнительные опции для production
  missingWarn: import.meta.env.DEV, // Warning только в dev mode
  fallbackWarn: import.meta.env.DEV,
})

/**
 * Хелпер для смены языка
 */
export function setLocale(locale: Locale): void {
  i18n.global.locale.value = locale
}

/**
 * Хелпер для получения текущего языка
 */
export function getLocale(): Locale {
  return i18n.global.locale.value
}
